export default __webpack_public_path__ + "ca637795c67bd9dbfa2d47903d4da3d6.svg";